import { useEffect, useState } from 'react'

/** Ticking clock used in the top navigation (store-local wall time). */
export function useLiveClock(intervalMs = 1000): Date {
  const [now, setNow] = useState<Date>(() => new Date())

  useEffect(() => {
    const timer = window.setInterval(() => setNow(new Date()), intervalMs)
    return () => window.clearInterval(timer)
  }, [intervalMs])

  return now
}
